import { render } from "./IconPercentage.vue?vue&type=template&id=0a1f863e"
import script from "./IconPercentage.vue?vue&type=script&lang=js"
export * from "./IconPercentage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__